<div [className]="className">
  <p class="social-buttons__text" *ngIf="description">{{ description }}</p>
  <div class="social-buttons__buttons" [class.flex-col]="isInlineVariant">
    <ng-container *ngFor="let button of buttonsConfig; let isLast = last">
      <app-social-button
        *ngIf="button.isShareButton"
        [name]="button.nameKey | translate"
        [ariaLabel]="button.ariaLabel"
        [iconType]="button.iconType"
        [variant]="variant"
        (click)="getMethod(button)"
        [shareButton]="button.name"
        [url]="getUrl(button)"
      ></app-social-button>

      <app-social-button
        *ngIf="!button.isShareButton"
        [name]="button.nameKey | translate"
        [ariaLabel]="button.ariaLabel"
        [iconType]="button.iconType"
        [url]="button.url"
        [variant]="variant"
        (click)="emitSelectSocialButton(button.name)"
      ></app-social-button>

      <app-divider
        *ngIf="!isLast && isInlineVariant"
        class="-my-1"
      ></app-divider>
    </ng-container>
  </div>
</div>
